export const RESERVED_ROLE_ID = 1;
export const ADMINISTRATOR_ROLE_ID = 21;
export const TRAINING_CENTER_ROLE_ID = 38;

const SCHEDULE_OVERVIEW_RESOURCE_NAME = 'ScheduleOverview';

export const roleHasAgendaAccess = (roleOption) => {
  const resources = roleOption?.resources;
  if (!Array.isArray(resources) || resources.length === 0) {
    return false;
  }

  return resources.some(
    (resource) => resource.name === SCHEDULE_OVERVIEW_RESOURCE_NAME && resource.canView === true
  );
};

export const shouldShowCtsField = (roleId, roleOption) =>
  roleId === TRAINING_CENTER_ROLE_ID || roleHasAgendaAccess(roleOption);

export const isCtsFieldRequired = (roleId) =>
  roleId !== RESERVED_ROLE_ID && roleId !== ADMINISTRATOR_ROLE_ID;
